
import './App.css'
import './index.css'
import './animations.css'
import { BrowserRouter, Route, Routes } from 'react-router-dom'
import Home from './pages/Home'
import Machines from './pages/Machines'
import Contact from './pages/Contact'
import Categories from './pages/Categories'
import AdminPanel from './pages/admin/AdminPanel'
import AdminLogin from './pages/admin/AdminLogin'
import AnnouncementDetails from './pages/AnnouncementDetails'
import CookiePolicy from './pages/CookiePolicy'
import { AppProvider } from './context/AppContext'
import CookieConsent from './components/CookieConsent/cookies-consent'


const App = () => {
  return (
    <AppProvider>
      <BrowserRouter>
        
        <Routes>

        <Route index element={<Home />}/>
        <Route path='/home' element={<Home />}/>
        <Route path='/machines' element={<Machines />}/>
        <Route path='/categories' element={<Categories />}/>
        <Route path='/contact' element={<Contact />}/>
        <Route path='/cookie-policy' element={<CookiePolicy />}/>
        <Route path='/announcement/:id/*' element={<AnnouncementDetails />}/>
        <Route path='/admin-login' element={<AdminLogin />}/>
        <Route path='/adminpanel' element={<AdminPanel />}/>

        </Routes>
        <CookieConsent />
        
        </BrowserRouter>
    </AppProvider>
  )
}

export default App